import { defineComponent } from 'vue';
import QuartlyProductionComponent from '@/components/QuartlyProduction/QuartlyProductionComponent.vue';
export default defineComponent({
    name: 'QuartlyProduction',
    components: { QuartlyProductionComponent },
    data() {
        return {};
    }
});
